module.exports = __webpack_public_path__ + "img/kusama.8a160b49.png";